import { render, staticRenderFns } from "./MouthRanking1.vue?vue&type=template&id=e8d90ae8&scoped=true"
import script from "./MouthRanking1.vue?vue&type=script&lang=js"
export * from "./MouthRanking1.vue?vue&type=script&lang=js"
import style0 from "./MouthRanking1.vue?vue&type=style&index=0&id=e8d90ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d90ae8",
  null
  
)

export default component.exports